import { render, staticRenderFns } from "./MaterialPDF.vue?vue&type=template&id=738c9ed2&scoped=true&"
import script from "./MaterialPDF.vue?vue&type=script&lang=js&"
export * from "./MaterialPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c9ed2",
  null
  
)

export default component.exports